import { Alert, Box, Button, Link as MuiLink } from "@mui/material";
import { useState } from "react";
import PassosCorretora from "./passosCorretora";
import { Link } from "react-router-dom";
import { radius } from "../../../../theme";

export default function UploadCorretora() {
  const [help, setHelp] = useState(false);
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      gap={1}
      py={2}
      width="100%"
    >
      <Alert
        color="info"
        variant="outlined"
        icon={false}
        sx={{ borderRadius: `${radius.md}px`, alignItems: "center" }}
        action={
          <Button
            variant="contained"
            color="primary"
            onClick={() => setHelp(true)}
          >
            Baixar
          </Button>
        }
      >
        1. Cadastre as Operações importando as Notas de Corretagem
      </Alert>
      <Alert
        color="info"
        variant="outlined"
        icon={false}
        sx={{ borderRadius: `${radius.md}px`, alignItems: "center" }}
      >
        2. Cadastre as{" "}
        <MuiLink
          component={Link}
          to="#subscricoes"
          sx={(theme) => ({
            color: theme.palette.accentInk,
            textDecorationColor: theme.palette.accentInk,
          })}
        >
          Subscrições
        </MuiLink>
      </Alert>

      <PassosCorretora onClose={() => setHelp(false)} open={help} />
    </Box>
  );
}
